// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"cf0c7575","4854":"671f044f","5055":"9fa22991","7265":"9fa22991","7506":"db1957ea"}[chunkId] + ".chunk.css";
};